import React from 'react';
import { Box, Avatar, Typography, Tooltip } from '@mui/material';

// Vendor identity: brand-ish color + short code used as a small badge/icon to tell the three
// monitoring systems apart. (Brand-colored initials, not the official logo assets — swap in real
// logo images here if desired.)
export const VENDOR = {
  apsystems: { label: 'APsystems', short: 'AP', color: '#EA5B0C' },
  solark: { label: 'Sol-Ark', short: 'SA', color: '#15396B' },
  eg4: { label: 'EG4', short: 'EG4', color: '#2E7D32' },
};

export const vendorLabel = (v) => (VENDOR[v]?.label || v);

// Vendor technical-support contacts (shown on the Solar page / detail boxes).
export const VENDOR_SUPPORT = {
  apsystems: { phone: '1-844-279-8600', email: 'support.usa@apsystems.com', portal: 'APsystems EMA', loginUrl: 'https://apsystemsema.com/ema/logoutForToDifferentPage.action?loginPageUrl=newLogin' },
  solark: { phone: '(972) 575-8875 (Ext. 2)', email: 'support@sol-ark.com', portal: 'MySolArk', loginUrl: 'https://www.solarkcloud.com/plants' },
  eg4: { phone: '903-609-1988', email: 'support@eg4electronics.com', email2: 'technicalsupport@eg4electronics.com', portal: 'EG4 Monitor (Luxpower)', loginUrl: 'https://monitor.eg4electronics.com/WManage/web/login' },
};

// Identifiers support asks for when you call — keyed per vendor from the site row + meta.
export function siteIdentifiers(site) {
  if (!site) return [];
  const out = [];
  const m = site.meta || {};
  if (site.vendor === 'apsystems') {
    out.push(['System ID (SID)', site.external_id]);
    if (Array.isArray(m.ecus) && m.ecus.length) out.push(['ECU IDs', m.ecus.join(', ')]);
  } else if (site.vendor === 'solark') {
    out.push(['Plant ID', site.external_id]);
  } else if (site.vendor === 'eg4') {
    out.push(['Inverter serial', site.external_id]);
    if (m.plantId) out.push(['Plant ID', String(m.plantId)]);
  } else {
    out.push(['ID', site.external_id]);
  }
  return out.filter(([, v]) => v != null && v !== '');
}

export function VendorBadge({ vendor, showLabel = true, size = 22 }) {
  const m = VENDOR[vendor] || { label: vendor, short: String(vendor || '?').slice(0, 2).toUpperCase(), color: '#6b6b6b' };
  const icon = (
    <Avatar variant="rounded" sx={{ width: size, height: size, bgcolor: m.color, color: '#fff',
      fontSize: Math.round(size * 0.42), fontWeight: 700, letterSpacing: 0 }}>
      {m.short}
    </Avatar>
  );
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
      {showLabel ? icon : <Tooltip title={m.label}>{icon}</Tooltip>}
      {showLabel && <Typography variant="caption" sx={{ fontWeight: 600 }}>{m.label}</Typography>}
    </Box>
  );
}
